import { createContext, useContext } from 'react';
import { IProcessTemplate } from '../../types';

export const ProcessDesignerTemplateContext = createContext<IProcessTemplate | null>(null);

export function useCurrentProcessDesignerTemplate() {
  return useContext(ProcessDesignerTemplateContext);
}
